exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".zmenu-navbar.navbar-default .navbar-nav > li > a {\r\n    color: #ffffff;\r\n}\r\n\r\n.zmenu-navbar.navbar-default .navbar-nav > li > a:hover,\r\n.zmenu-navbar.navbar-default .navbar-nav > li > a:focus,\r\n.zmenu-navbar.navbar-default .navbar-nav > .open > a,\r\n.zmenu-navbar.navbar-default .navbar-nav > .open > a:hover,\r\n.zmenu-navbar.navbar-default .navbar-nav > .open > a:focus {\r\n    color: #ffffff;\r\n    background-color: rgba(255, 255, 255, 0.12);\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/modules/zmenu/components/zmenu-root.style.css
// module id = 1172
// module chunks = 0